<template>
  <div class="max-w-[50rem] p-8 mx-auto w-full h-full relative">
    <DataGetter
      @dataAvailable="
        data => {
          subscription = data?.metaData || {}
        }
      "
      contentId="subscription"
    />
    <DataGetter
      @dataAvailable="
        data => {
          appInfo = data?.metaData || {}
        }
      "
      contentId="appInfo"
    />
    <div
      class="bg-[#FBFBFC] h-full py-6 rounded-3xl shadow-b-xl"
      v-if="products.length !== 0"
    >
      <div class="h-full px-6 overflow-auto flex flex-col">
        <div class="absolute right-12 top-12" @click="$router.back">
          <img
            src="@/assets/images/all/close.svg"
            class="w-[30px] h-[30px] cursor-pointer full-screen-modal-close-button-black"
            alt=""
          />
        </div>
        <div class="text-center font-bold title-color text-3xl">
          Lancer un promotion
        </div>
        <div class="py-4"></div>

        <div class="h-full overflow-hidden -mx-6">
          <div
            class="grid relative grid-cols-2 h-full w-[200%] duration-300"
            :class="{ 'left-0': !isPickingDate, '-left-full': isPickingDate }"
          >
            <div class="flex-col flex h-full overflow-auto px-6" px>
              <div class="text-center">
                Sélectionner les produits à promouvoir
              </div>

              <div class="overflow-auto h-full pr-4">
                <div class="flex flex-col gap-4">
                  <div
                    v-for="(product, i) in products"
                    :key="i"
                    class="flex items-center gap-6 rounded-2xl p-4 ripple"
                    :class="{
                      'bg-primary-100 ': selectedProductsIds.includes(
                        product.id,
                      ),
                      'bg-gray-100 ': !selectedProductsIds.includes(product.id),
                    }"
                    @click="toggleProductSelection(product, i)"
                  >
                    <div class="w-20 h-20">
                      <img
                        :src="product.image"
                        class="w-full h-full object-cover rounded-2xl"
                        alt=""
                      />
                    </div>
                    <div>
                      {{ product.name }}
                    </div>
                    <div class="ml-auto">
                      <div class="w-[1.5rem] h-[1.5rem] relative">
                        <div
                          class="duration-300 rounded-full border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                          :class="{
                            'border-primary w-[0.8rem] h-[0.8rem] bg-primary':
                              selectedProductsIds.includes(product.id),
                            'border-primary-300 w-[1.5rem] h-[1.5rem] bg-[transparent]':
                              !selectedProductsIds.includes(product.id),
                          }"
                        ></div>
                        <div
                          class="duration-300 rounded-full border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                          :class="{
                            'border-primary w-[1.5rem] h-[1.5rem] bg-[transparent]':
                              selectedProductsIds.includes(product.id),
                            'border-[transparent] w-[1.5rem] h-[1.5rem] bg-[transparent]':
                              !selectedProductsIds.includes(product.id),
                          }"
                        >
                          <!-- <img
                            src="@/assets/images/all/check-normal-white.svg"
                            alt=""
                          /> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pt-4">
                <button
                  class="buttonComponent w-full"
                  @click="acceptSelectedProducts"
                  :class="{
                    'pointer-events-none opacity-50':
                      selectedProducts.length == 0,
                  }"
                >
                  Continuer

                  <!-- <div
                    class="top-0 right-0 translate-x-1/2 -translate-y-1/2 rounded-full absolute w-6 h-6 border border-primary bg-white text-primary"
                  >
                    {{ selectedProducts.length }}
                  </div> -->
                </button>
              </div>
            </div>
            <div class="flex-col flex h-full overflow-auto px-6" px>
              <div @click="isPickingDate = false">
                <img
                  src="@/assets/images/all/arrow-up.svg"
                  class="w-[1.5rem] h-[1.5rem] -rotate-90 cursor-pointer full-screen-modal-close-button-black"
                  alt=""
                />
              </div>
              <div class="text-center">Sélectionez la période de promotion</div>
              <div class="py-2"></div>
              <div class="overflow-auto h-full pr-4 flex justify-center w-full">
                <div>
                  <VueDatePicker
                    v-model="date"
                    range
                    inline
                    auto-apply
                    :disabled-dates="disabledDates"
                    :enable-time-picker="false"
                    :min-date="today"
                    prevent-min-max-navigation
                  />
                </div>
              </div>

              <div class="py-2"></div>
              <div class="text-center font-bold">
                {{ promotionDuration }} Jours
              </div>
              <div class="pt-4">
                <button
                  class="buttonComponent w-full"
                  @click="confirmDurationPromition"
                  :class="{
                    'pointer-events-none opacity-50': !promotionDuration,
                  }"
                >
                  Continuer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <EventListener
      :events="[
        'promotion_payment_launched',
        'failed_to_launch_promotion_payment',
        'transaction_url_available',
        'collection_finished_available',
        'iframe_closed',
      ]"
      @promotion_payment_launched="onPaymentLaunched"
      @failed_to_launch_promotion_payment="onPaymentFailedToLaunch"
      @transaction_url_available="onPaymentUrlAvailable"
      @collection_finished_available="onPaymentFinished"
      @iframe_closed="onIframeClosed"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import moment from 'moment'
import '@vuepic/vue-datepicker/dist/main.css'
import VueDatePicker from '@vuepic/vue-datepicker'
import DataGetter from '../utils/DataGetter.vue'
import EventListener from '../utils/EventListener.vue'

export default defineComponent({
  name: 'AddNewTopProduct',
  components: { VueDatePicker, DataGetter, EventListener },
  data() {
    return {
      eventsIds: [], // Stocke les IDs des écouteurs d'événements
      products: [],
      listenLaunchedTransaction: false,
      isPickingDate: false,
      subscription: {},
      appInfo: {},
      selectedProducts: [],
      selectedDates: [],
      date: null,
      today: new Date(),
      disabledDates: [],
    }
  },
  mounted() {
    // Écoute des événements pour la création de la promotion
    const id = this.$Events.handleEvent(
      'topproduct_created',
      this.onTopProductCreated,
    )
    const id2 = this.$Events.handleEvent(
      'failed_to_create_topproduct',
      this.onTopProductCreationFailed,
    )
    this.eventsIds.push(id, id2)
    this.loadProducts()
  },
  beforeUnmount() {
    // Nettoyage des écouteurs d'événements
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    async loadProducts() {
      const data = await this.$Events.sendDataRequestResolve('products')
      if (!data?.length) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Aucun produit',
          body: 'Ajouter des produits avant de les promouvoir',
        })
        this.$router.back()
        return
      }
      this.products = data
    },
    onTopProductCreated(data) {
      console.log(data)
      let title = 'TopProduct Crée'
      let body = 'Votre topproduct a été créé avec succès'
      if (!data.atLeastOneCreated) {
        title = 'TopProduct non créé'
        body = "Nous n'avons pas pu créer votre topproduct, veuillez réessayer"
      }
      if (data.allTopProductCreated) {
        title = 'TopProduct non créé'
        body = "Tous les produits sélectionnés bénéficient d'un discount"
      }
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title,
        body,
      })
      this.$router.back()
    },
    onTopProductCreationFailed() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'TopProduct non créé',
        body: 'Erreur de création de la promotion, veuillez réessayer',
      })
    },
    toggleProductSelection(product) {
      this.selectedProducts = [product]
      // if (this.selectedProductsIds.includes(product.id)) {
      //   this.selectedProducts.splice(
      //     this.selectedProductsIds.indexOf(product.id),
      //     1,
      //   )
      // } else if (this.selectedProducts.length >= this.maxProductsSelectable) {
      //   this.$Events.dispatchEvent('toast_notification', {
      //     title: 'Limite atteinte',
      //     body: `Vous ne pouvez pas sélectionner plus de ${this.maxProductsSelectable} produits`,
      //   })
      //   return
      // } else this.selectedProducts.push(product)
    },
    async acceptSelectedProducts() {
      this.isPickingDate = true
      // this.$refs.dateModal.show()
      // const details = await this.askTopProductDetails()
      // if (!details) return
      // const topproductsData = {
      //   ...details,
      //   products: this.selectedProducts,
      // }

      // this.$Events.dispatchEvent(
      //   'many_topproducts_ready_to_be_added',
      //   topproductsData,
      // )
      // this.$Events.dispatchEvent('start_loading')
    },
    async confirmDurationPromition() {
      this.$Events.dispatchEvent('start_loading', {
        title: 'Vérification de la disponibilité',
      })

      const bookingDetails = await this.$Events.sendDataRequestResolve(
        'promotionBookingDetails',
        {
          startDate: this.date[0].getTime(),
          endDate: this.date[1].getTime(),
        },
      )
      await new Promise(r => setTimeout(r, 500))
      this.$Events.dispatchEvent('finish_loading')

      if (
        this.promotionDuration < this.appInfo.topProductPromotionMinDuration
      ) {
        this.$Events.dispatchEvent('toast_notification', {
          title: "Désolé, la durée minimal d'une promotion est de 7 jours",
          body: 'Veuillez augmenter la durée de votre promotion',
        })
        return
      }

      if (!bookingDetails || bookingDetails.statusCode !== 200) {
        this.$Events.dispatchEvent('toast_notification', {
          title: "Nous n'avons pas pu contacter les serveurs",
          body: "Désolé, nous n'arrivons pas à contacter nos serveurs, veuillez réessayer",
        })
        return
      }

      if (!bookingDetails.periodIsAvailable) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Désolé, certains jours sont déjà occcupé',
          body: "Veuillez sélectionner d'autres dates et réessayer",
        })
        return
      }

      const cost =
        this.promotionDuration *
        this.appInfo.topProductPromotionCostPerDay *
        this.selectedProducts.length

      const prompt = await window.choicePrompt({
        title: `Le cout total de la promotion de ${this.promotionDuration} jours est de ${cost} FCFA`,
        subTitle: `Comment voulez-vous effectuer le paiement?`,
        options: [
          {
            title: 'Payer par mobile money',
            id: 'mobileMoney',
          },
          {
            title: 'Payer par carte bancaire',
            id: 'card',
          },
        ],
        formatDisplay: data => data?.title || '',
        successText: 'Payer',
      })
      if (!prompt.accepted || !prompt.data) return null
      await new Promise(r => setTimeout(r, 500))
      this.$Events.dispatchEvent('start_loading')
      this.listenLaunchedTransaction = true

      this.$Events.dispatchEvent('promotion_ready_to_be_launched', {
        startDate: this.date[0].getTime(),
        endDate: this.date[1].getTime(),
        products: this.selectedProducts,
        paymentMethod: prompt.data.id,
      })
    },
    async askTopProductDetails() {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: 'Configurez votre topproduct',
          // subTitle: 'Sélectionnez la couleur et sélectionner une image qui y',
          formFields: [
            {
              type: 'date',
              propertyName: 'startDate',
              label: 'Date de début',
              inputProps: {},
              defaultValue: this.$Commons.time(Date.now(), 'YYYY-MM-DD'),
              required: true,
            },
            {
              type: 'date',
              propertyName: 'endDate',
              label: 'Date de fin',
              defaultValue: this.$Commons.time(
                Date.now() + 24 * 60 * 60 * 1000,
                'YYYY-MM-DD',
              ),
              required: true,
            },
            {
              type: 'number',
              propertyName: 'discount',
              label: 'Réduction',
              inputProps: {
                suffix: '%',
                min: '0.1',
                max: '100',
                placeHolder: 'Appliquer une réduction',
                numberStep: 0.01,
              },
              defaultValue: 5,
              class: '',
              required: true,
            },
          ],
          successText: 'Ajouter',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      return {
        discount: prompt.data.discount,
        startDate:
          moment(prompt.data.startDate)
            .set('h', 0)
            .set('minute', 0)
            .set('s', 0)
            .unix() * 1000,
        endDate:
          moment(prompt.data.endDate)
            .set('h', 23)
            .set('minute', 59)
            .set('s', 59)
            .unix() * 1000,
      }
    },

    onPaymentLaunched() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Paiement lancé',
        body: 'La paiement a été lancé. Veuillez patienter et confirmer',
      })
    },
    onPaymentFailedToLaunch() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Paiement non lancé',
        body: "Echec d'initiation du paiement, veuillez réessayer.",
      })
    },
    onPaymentUrlAvailable({ url, id }) {
      if (!this.listenLaunchedTransaction) return
      console.log(id)
      this.listenLaunchedTransaction = false
      this.latestTransactionUrl = url
      this.latestTransactionId = id
      this.$Events.dispatchEvent('url_opening_required', {
        url: url,
        useIframe: true,
        iframeClasses: 'w-full h-full',
      })
    },
    onPaymentFinished({ id, status }) {
      console.log(id, this.latestTransactionId)
      if (id == this.latestTransactionId) {
        this.$Events.dispatchEvent('close_iframe')
        this.$Events.dispatchEvent('subscription_payment_done')
        this.latestTransactionId = ''
        this.latestTransactionUrl = ''
        if (status == 'success') {
          this.$Events.dispatchEvent('toast_notification', {
            title: 'Paiement réussi',
            body: 'La souscription à la promotion a été faite',
          })
          setTimeout(() => {
            window.location.reload()
          }, 5000)
        } else {
          this.$Events.dispatchEvent('toast_notification', {
            title: 'Echec du paiement',
            body: "Le paiement de votre promotion n'a pas réussi, veuillez réessayer",
          })
        }
      }
    },
    onIframeClosed({ url }) {
      console.log('iframe closedd', url, this.latestTransactionUrl)
      if (url !== this.latestTransactionUrl) return
      this.latestTransactionId = ''
      this.latestTransactionUrl = ''
      this.listenLaunchedTransaction = false
    },
  },
  computed: {
    selectedProductsIds() {
      return this.selectedProducts.map(product => product.id)
    },
    promotionDuration() {
      if (!this.date) return 0
      const date1 = moment(this.date[0])
      const date2 = moment(this.date[1])
      const duration = date2.diff(date1, 'd')
      return duration + 1
    },
    maxProductsSelectable() {
      return 999999999999
      // if (this.subscription.isActive) return 20
      // return 10
    },
  },
})
</script>

<style>
/* .dp__theme_light {
  --dp-background-color: #fff;
  --dp-text-color: #212121;
  --dp-hover-color: #f3f3f3;
  --dp-hover-text-color: #212121;
  --dp-hover-icon-color: #959595;
  --dp-primary-color: #1976d2;
  --dp-primary-disabled-color: #6bacea;
  --dp-primary-text-color: #f8f5f5;
  --dp-secondary-color: #c0c4cc;
  --dp-border-color: #ddd;
  --dp-menu-border-color: #ddd;
  --dp-border-color-hover: #aaaeb7;
  --dp-border-color-focus: #aaaeb7;
  --dp-disabled-color: #f6f6f6;
  --dp-scroll-bar-background: #f3f3f3;
  --dp-scroll-bar-color: #959595;
  --dp-success-color: #76d275;
  --dp-success-color-disabled: #a3d9b1;
  --dp-icon-color: #959595;
  --dp-danger-color: #ff6f60;
  --dp-marker-color: #ff6f60;
  --dp-tooltip-color: #fafafa;
  --dp-disabled-color-text: #8e8e8e;
  --dp-highlight-color: rgb(25 118 210 / 10%);
  --dp-range-between-dates-background-color: var(--dp-hover-color, #f3f3f3);
  --dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121);
  --dp-range-between-border-color: var(--dp-hover-color, #f3f3f3);
} */
</style>
